import Cookies from 'js-cookie';
import { createStore, applyMiddleware } from 'redux';
import update from 'immutability-helper'
import * as Actions from './redux-actions.js'

const clone = require('rfdc')()


const initialState = { authenticated: false, 
                       current_user: null, 
                       current_role: null,
                       serverStatus: true,
                       db: {}}

const Reducer = function (state=initialState, action) {
  let newState = {}
  let index

  switch(action.type) {
    
    case Actions.SET_ALERT:
         newState = update(state, {alert: {$set: action.alert }} )
         if (state.alert && state.alert.timeout && action.alert.visible === false) {
           clearTimeout(state.alert.timeout)
         }
         return newState

    case Actions.SET_SERVER_STATUS:
         if (state.serverStatus !== action ) {
            newState = update(state, {serverStatus: {$set: action.value }} )
            return newState    
          } else {
            return
          }


    case Actions.LOAD_DICTIONARY:
         newState = update(state, {dictionary: {$set: action.value }} )
         return newState    

    case Actions.SET_BOOKINGS:
         newState = update(state, {db: {bookings:  {$set: action.value }}} )
         return newState    


    case Actions.UPDATE_TRANSFER_PRICE:
         newState = state
         newState.dictionary.transfer_price = clone(state.dictionary.transfer_price)
         index = newState.dictionary.transfer_price.findIndex(r => r.ttype_id === action.row.ttype_id && r.region_id === action.row.region_id && r.car_type === action.row.car_type)
         if (index === -1) {
           newState.dictionary.transfer_price.push(action.row)
         } else {
           newState.dictionary.transfer_price[index] = action.row
         }
         
         return newState

    case Actions.UPDATE_SIMCARD:
         newState = state
         newState.dictionary.sim_cards = clone(state.dictionary.sim_cards)
         if (action.delete) {
           index = newState.dictionary.sim_cards.findIndex(r => r.id === action.id)
           if (index !== -1) {
             newState.dictionary.sim_cards.splice(index,1)
           } else {
             return state
           }
         } else if (action.update) {
           index = newState.dictionary.sim_cards.findIndex(r => r.id === action.update)
           if (index === -1) {
             newState.dictionary.sim_cards.push(action.row)
           } else {
             newState.dictionary.sim_cards[index] = action.row
           }
         } else {
            newState.dictionary.sim_cards.push(action.row)
         }
         return newState

    case Actions.UPDATE_BOOKING:
         newState = clone(state)
         index = newState.db.bookings.findIndex(r => r.id === action.id)
         if (action.column === "price_azn") {
           newState.db.bookings[index].price_updated = "YES"
           newState.db.bookings[index].price_azn = action.value.azn
           newState.db.bookings[index].price_eur = action.value.eur
         } else {
           newState.db.bookings[index][action.column] = action.value
         }
         return newState


    case Actions.SET_TRANSFERS:
         newState = update(state, {db: {transfers:  {$set: action.value }}} )
         return newState    

    case Actions.UPDATE_TRANSFER:
         newState = clone(state)
         index = newState.db.transfers.findIndex(r => r.book_id === action.book_id && r.transfer_type_id === action.transfer_type_id)
         newState.db.transfers[index][action.column] = action.value
         return newState


    case Actions.LOGIN:
         newState = update(state, {authenticated: {$set: true }, current_user: {$set: action.user}, current_role: {$set: action.role}} )
         return newState    

    case Actions.LOGOUT:
         newState = update(state, {authenticated: {$set: false }, current_user: {$set: null}, current_role: {$set: null}} )
         return newState    


    default:
        return state
  }
}



/**
 * Logs all actions and states after they are dispatched.
 */
const logger = store => next => action => {
  console.group(action.type)
  console.info('dispatching', action)
  let result = next(action)
  console.log('next state', store.getState())
  console.groupEnd(action.type)
  return result
}

var createStoreWithMiddleware = applyMiddleware(logger)(createStore)

var Store = createStoreWithMiddleware(Reducer)

export default Store

